/* global $:false */

/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

export default class ValuationRequestCategory {
  static init () {
    return Array.from($('[data-valuation-request-category]')).map((select) =>
      new ValuationRequestCategory($(select)))
  }

  constructor ($select) {
    this.instructions = $select.data('valuation-request-category')
    const $target = $('[data-direct-upoad-instruction]')
    $select.on('change', event => {
      const instruction = this.instructions[$select.val()]
      if (!instruction) { return }
      return $target.html(instruction)
    })
  }
}
